/// <amd-module name="Analytics/Shared/AadTokenGenerator/Constants" />
export const prod_redirect_url = "https://dev.azure.com/";
export const devfab_redirect_url = "https://codedev.ms/";
export const resource = "https://analysis.windows.net/powerbi/api";
export const instance = "https://login.microsoftonline.com/";
export const tenant = "72f988bf-86f1-41af-91ab-2d7cd011db47";
export const client_id = "5acff0b7-0073-4811-9fb4-38264662de92";
